module.exports = __webpack_public_path__ + "static/media/sasha-grey-icon.74a8b131.jpg";